import { useCallback } from 'react';
import { useAppDispatch } from 'redux/store';
import { exportCourseContent } from 'redux/actions/courses';
import { addAlertMessage } from 'redux/actions/alert-messages';
import { wrapThunkAction } from 'redux/utils';
import t from 'react-translate';
import { AlertMessageType } from 'redux/schemas/app/alert-message';
import { getCourseAliases } from 'redux/selectors/course';
import { useSelector } from 'react-redux';

/* @ngInject */
export function useCourseContentExport(catalogId: string) {
  const dispatch = useAppDispatch();
  const aliases = useSelector((state) => getCourseAliases(state, catalogId));

  const startExport = useCallback(
    (courseName: string) => wrapThunkAction(dispatch(exportCourseContent(catalogId)))
      .then(() => {
        dispatch(addAlertMessage({
          type: AlertMessageType.INFO,
          header: t.CONTENT_EXPORT.EXPORTING_TITLE({ ...aliases.courseAliases, courseName }),
          message: t.CONTENT_EXPORT.EXPORTING_DESCRIPTION(aliases.courseAliases),
        }));
      })
      .catch(() => {
        dispatch(addAlertMessage({
          type: AlertMessageType.ERROR,
          header: t.FORM.OOPS(),
          message: t.FORM.ERROR_SOMETHING_WRONG(),
        }));
      }),
    [dispatch, catalogId, aliases.courseAliases],
  );

  return { startExport };
}

export default useCourseContentExport;
